import { useResource } from '@landsbankinn/l16n';
import { Dropdown, useInputValidation } from '@landsbankinn/ui';
import groupBy from 'lodash.groupby';
import React, { useEffect, useMemo, useState } from 'react';
import { Region } from '../../../../../__generated__/globalTypes';
import { useRegionOptions } from '../../../../components/service-points/filters/RegionDropdown';
import { useAppointmentContext } from '../../../book-appointment/BookAppointment';

import res from './SelectService.res';

export function AppointmentSelectBranch() {
  const { r } = useResource();
  const { options } = useRegionOptions();
  const { state, dispatch } = useAppointmentContext();
  const { service, serviceType, serviceLocationId } = state;

  const [ref, isValid] = useInputValidation(state?.serviceLocationId, [
    {
      validation: (value) => value !== undefined,
    },
  ]);

  const [availableLocations, setAvailableLocations] = useState(
    service?.types?.find((i) => i.type === serviceType)
      ?.availableServiceLocation,
  );

  const groupedOptions = useMemo(() => {
    const groupedBrances = groupBy(availableLocations, (b) => b.region);
    return Object.keys(groupedBrances).map(function (key) {
      return {
        label: options.find((op) => op.value === Region[key])?.label,
        options: groupedBrances[key].map((item) => ({
          label: item?.name,
          value: item?.id,
        })),
      };
    });
  }, [options, availableLocations]);

  useEffect(() => {
    setAvailableLocations(
      service?.types?.find((i) => i.type === serviceType)
        ?.availableServiceLocation,
    );
  }, [serviceType, service]);

  return (
    <Dropdown
      isValid={isValid}
      variant="noBorder"
      labelVariant="aboveInput"
      errorMessageVariant="insideInput"
      buildOption={(val) => val}
      options={groupedOptions}
      onChange={(val) => {
        dispatch?.({
          type: 'selectServiceLocationId',
          serviceLocationId: val?.value as any,
        });
      }}
      value={
        serviceLocationId !== undefined
          ? {
              label: availableLocations?.find((i) => i.id === serviceLocationId)
                ?.name,
              value: availableLocations?.find((i) => i.id === serviceLocationId)
                ?.name,
            }
          : undefined
      }
      label={r(res.pickBranch)}
    />
  );
}
